export const USER_ACTION_OPTIONS = [
    { value: "update", label: "Update" },
    { value: "addAccountManager", label: "Add Account Manager" },
    { value: "updateUserSuspendStatus", label: "Update Suspend Status" },
    { value: "updateUserTagging", label: "Update User Tagging" },
    { value: "updateUserPackage", label: "Update User Package" },
    { value: "chargeUser", label: "Charge User Card" },
    { value: "updateCodValue", label: "Update COD Value" },
    { value: "manualConfirmEmail", label: "Manually Confirm Email" },
    { value: "updateUserDetails", label: "Update User Details" },
    { value: "updateUserFeatures", label: "Update User Features" },
    { value: "inheritUserFeatures", label: "Inherit Features" },
    { value: "removeFeatureInheritance", label: "Remove Inheritance" },
    { value: "syncUserFeatures", label: "Synced From Master" },
    { value: "manageUserCredit", label: "Manage User Credit" },
    { value: "updateServiceProviderConfigs", label: "Update Courier Custom Config" },
    { value: "approveCancelRequest", label: "Approve Cancel Request" },
    { value: "rejectCancelRequest", label: "Reject Cancel Request" },
    { value: "updateSettings", label: "Update Settings" },
    { value: "updateAnnouncement", label: "Update Announcement" },
    { value: "syncBrevo", label: "Sync Brevo" },
    { value: "addVoucherToAccountManager", label: "Add Voucher To Account Manager" },
    { value: "importAccountManagerAssignments", label: "Import Account Manager Assignments" },
    { value: "addUserNote", label: "Add User Note" },
    { value: "exportUserListCsv", label: "Export User List CSV" },
    { value: "exportDangerUserListCsv", label: "Export Danger User List CSV" },
    { value: "lockMemberTier", label: "Lock Member Tier" },
    { value: "resetPackageLockedDate", label: "Reset Package Locked Date" },
    { value: "updateMerchantPreferences", label: "Update Merchant Preferences" },
    { value: "syncOrderStatus", label: "Sync Order Status" },
    { value: "markOrderCancelled", label: "Mark Order Cancelled" },
    { value: "refundOrder", label: "Refund Order" },
    { value: "refundCod", label: "Refund COD" },
    { value: "bulkRefundCod", label: "Bulk Refund COD" },
    { value: "bulkCancelOrders", label: "Bulk Cancel Orders" },
    { value: "exportOrderListCsv", label: "Export Order List CSV" },
    { value: "viewInvoice", label: "View Invoice" },
    { value: "bulkDownloadConnote", label: "Bulk Download Connote" },
    { value: "updateRemittanceStatuses", label: "Update Remittance Statuses" },
    { value: "bulkCheckRemittance", label: "Bulk Check Remittance" },
    { value: "updateWeightDispute", label: "Update Weight Dispute" },
    { value: "refundWeightDispute", label: "Refund Weight Dispute" },
    { value: "bulkRefundWeightDispute", label: "Bulk Refund Weight Dispute" },
    { value: "newPayout", label: "New Payout" },
    { value: "processBulkPayout", label: "Process Bulk Payout" },
    { value: "processWithdrawal", label: "Process Withdrawal" },
    { value: "cancelPayout", label: "Cancel Payout" },
    { value: "updateBeneficiaryStatus", label: "Update Beneficiary Status" },
    { value: "updatePayoutProvider", label: "Update Payout Provider" },
    { value: "rejectBeneficiaryRequest", label: "Reject Beneficiary Request" },
    { value: "uploadClaimPayout", label: "Upload Claim Payout" },
    { value: "payClaimPayout", label: "Pay Claim Payout" },
    { value: "checkInvoiceStatus", label: "Check Invoice Status" },
    { value: "createInvoice", label: "Create Invoice" },
    { value: "exportTransactionsCsv", label: "Export Transactions CSV" },
    { value: "createNews", label: "Create News" },
    { value: "updateNewsStatus", label: "Update News Status" },
    { value: "updatePricing", label: "Upload Pricing" },
    { value: "updateCost", label: "Upload Cost" },
    { value: "updateFeePricing", label: "Upload Fee Pricing" },
    { value: "updateCourierPricing", label: "Upload Courier Pricing" },
    { value: "createQuestionaireQuestion", label: "Create Questionaire Question" },
    { value: "editQuestionaireQuestion", label: "Edit Questionaire Question" },
    { value: "uploadQuestionaire", label: "Upload Questionaire" },
    { value: "toggleQuestionaireStatus", label: "Toggle Questionaire Status" },
    { value: "createDiscountCode", label: "Create Discount Code" },
    { value: "updateDiscountCode", label: "Update Discount Code" },
    { value: "toggleDiscountCodeStatus", label: "Toggle Discount Code Status" },
    { value: "archiveDiscountCode", label: "Delete Discount Code" },
    { value: "createVoucher", label: "Create Voucher" },
    { value: "updateVoucher", label: "Update Voucher" },
    { value: "archiveVoucher", label: "Archive Voucher" },
    { value: "updateVoucherSetting", label: "Update Voucher Setting" },
    { value: "dispatchVouchers", label: "Dispatch Vouchers" },
    { value: "createBanner", label: "Create Banner" },
    { value: "updateBanner", label: "Update Banner" },
    { value: "toggleBannerStatus", label: "Toggle Banner Status" },
    { value: "deleteBanner", label: "Delete Banner" },
    { value: "createCampaign", label: "Create Campaign" },
    { value: "updateCampaign", label: "Update Campaign" },
    { value: "toggleCampaign", label: "Toggle Campaign" },
    { value: "createMission", label: "Create Mission" },
    { value: "updateMission", label: "Update Mission" },
    { value: "toggleMissionStatus", label: "Toggle Mission Status" },
    { value: "archiveMission", label: "Archive Mission" },
    { value: "unarchiveMission", label: "Unarchive Mission" },
    { value: "createCurrencyConversionRule", label: "Create Currency Conversion Rule" },
    { value: "updateCurrencyConversionRule", label: "Update Currency Conversion Rule" },
    { value: "toggleCurrencyConversionRule", label: "Toggle Currency Conversion Rule" },
    { value: "archiveCurrencyConversionRule", label: "Archive Currency Conversion Rule" },
    { value: "unarchiveCurrencyConversionRule", label: "Unarchive Currency Conversion Rule" },
    { value: "updateRedemptionSettings", label: "Update Redemption Settings" },
    { value: "createRewardItem", label: "Create Reward Item" },
    { value: "updateRewardItem", label: "Update Reward Item" },
    { value: "toggleRewardItemStatus", label: "Toggle Reward Item Status" },
    { value: "archiveRewardItem", label: "Archive Reward Item" },
    { value: "unarchiveRewardItem", label: "Unarchive Reward Item" },
    { value: "createAnnouncement", label: "Create Announcement" },
    { value: "bulkCreateAnnouncements", label: "Bulk Create Announcements" },
    { value: "updateAnnouncementUsers", label: "Update Announcement Users" },
    { value: "createIssue", label: "Create Support Ticket" },
    { value: "bulkCreateIssues", label: "Bulk Create Support Tickets" },
    { value: "assignIssue", label: "Assign Support Ticket" },
    { value: "bulkUpdateIssueComments", label: "Bulk Update Ticket Comments" },
    { value: "addIssueComment", label: "Add Support Ticket Comment" },
    { value: "verifyCargoActivation", label: "Verify Cargo Activation" },
    { value: "createFlyerRequest", label: "Create Flyer Request" },
    { value: "updateFlyerRequest", label: "Update Flyer Request" },
    { value: "archiveFlyerRequest", label: "Delete Flyer Request" },
    { value: "bulkUpdateFlyerRequests", label: "Bulk Update Flyer Requests" },
    { value: "createNotification", label: "Create Notification" },
    { value: "createRiderPickup", label: "Create Rider Pickup" },
    { value: "cancelRiderPickup", label: "Cancel Rider Pickup" },
    { value: "createPricingPackageLabel", label: "Create Pricing Package Label" },
    { value: "updatePricingPackageLabel", label: "Update Pricing Package Label" },
    { value: "refund", label: "Refund Redemption" },
]

export const AUDIT_LOG_SUBJECT_OPTIONS = [
    { value: "_User", label: "User" },
    { value: "Merchant", label: "Merchant" },
    { value: "Order", label: "Order" },
    { value: "Settings", label: "Settings" },
    { value: "Transaction", label: "Transaction" },
    { value: "Payout", label: "Payout" },
    { value: "Beneficiary", label: "Beneficiary" },
    { value: "Pricing", label: "Pricing" },
    { value: "Cost", label: "Cost" },
    { value: "CourierPricing", label: "Courier Pricing" },
    { value: "FeePricing", label: "Fee Pricing" },
    { value: "InternationalPricing", label: "International Pricing" },
    { value: "InternationalCost", label: "International Cost" },
    { value: "InternationalCourierPricing", label: "International Courier Pricing" },
    { value: "News", label: "News" },
    { value: "Questionaire", label: "Questionaire" },
    { value: "DiscountCode", label: "Discount Code" },
    { value: "Voucher", label: "Voucher" },
    { value: "Banner", label: "Banner" },
    { value: "Campaign", label: "Campaign" },
    { value: "Mission", label: "Mission" },
    { value: "CurrencyConversionRule", label: "Currency Conversion Rule" },
    { value: "RedemptionSettings", label: "Redemption Settings" },
    { value: "RewardItem", label: "Reward Item" },
    { value: "Redemption", label: "Redemption" },
    { value: "Announcement", label: "Announcement" },
    { value: "Issue", label: "Support Ticket" },
    { value: "CargoActivation", label: "Cargo Activation" },
    { value: "FlyerRequest", label: "Flyer Request" },
    { value: "Notification", label: "Notification" },
    { value: "RiderInfo", label: "Rider Pickup" },
    { value: "PricingPackageLabel", label: "Pricing Package Label" },
]

export const AUDIT_LOG_TYPE_OPTIONS = [
    { value: "USER", label: "User" },
    { value: "ADMIN", label: "Admin" },
    { value: "SETTINGS", label: "Settings" },
]

export const USER_ACTION_LABEL_MAP = Object.fromEntries(
    USER_ACTION_OPTIONS.map(opt => [opt.value, opt.label])
)

export const AUDIT_LOG_SUBJECT_MAP = Object.fromEntries(
  AUDIT_LOG_SUBJECT_OPTIONS.map(opt => [opt.value, opt.label])
)

export const AUDIT_LOG_TYPE_MAP = Object.fromEntries(
  AUDIT_LOG_TYPE_OPTIONS.map(opt => [opt.value, opt.label])
)
